(function() {
  var HybridOption, PlantingPlanFactory, PlantingToRxConverter, RxPlanFactory,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  HybridOption = App.loadClass('grower::classes/placement/HybridOption');

  PlantingPlanFactory = App.loadClass('grower::viewmodels/placement/seed_options/PlantingPlanFactory');

  PlantingToRxConverter = App.loadClass('grower::viewmodels/placement/seed_options/PlantingToRxConverter');

  RxPlanFactory = App.loadClass('grower::viewmodels/placement/seed_options/RxPlanFactory');

  exports.Form = (function(superClass) {
    extend(Form, superClass);

    Form.prototype.setInitialDeps = function() {
      Form.__super__.setInitialDeps.call(this);
      return this.syncDeps({
        'Seed_Options_Field': 'grower::viewmodels/placement/seed_options/Field'
      });
    };

    function Form(handler) {
      this.selectRefuge = bind(this.selectRefuge, this);
      this.getPrevRefuges = bind(this.getPrevRefuges, this);
      this.getNextRefuges = bind(this.getNextRefuges, this);
      this.selectLowYieldHybrid = bind(this.selectLowYieldHybrid, this);
      this.getPrevLowYieldHybrids = bind(this.getPrevLowYieldHybrids, this);
      this.getNextLowYieldHybrids = bind(this.getNextLowYieldHybrids, this);
      this.selectHybrid = bind(this.selectHybrid, this);
      this.getPrevHybrids = bind(this.getPrevHybrids, this);
      this.getNextHybrids = bind(this.getNextHybrids, this);
      this.createRxPlan = bind(this.createRxPlan, this);
      this.convertPlanToRx = bind(this.convertPlanToRx, this);
      this.createPlantingPlan = bind(this.createPlantingPlan, this);
      Form.__super__.constructor.call(this);
      this.handler = handler;
      this.selectionsKO = handler.selectionsKO;
      this.writer = $(this.handler.parent.layoutSelector).find('.message_writer');
      this.spp = handler.parent;
      this.taffy = this.spp.taffyObjects;
      this.spp_id = this.spp.sppID;
      this.results_id = this.spp.resultID;
      this.fields = [];
      this.initialVisibleFieldNum = 0;
      this.btnContents = this.spp.hybridButtonContents;
      this.numResults = this.spp.numVisibleResults;
      this.spanCls = 'span' + Math.round(12 / this.numResults);
      this._initFields();
      this._initKO();
    }

    Form.prototype._initFields = function() {
      var doSPP;
      this.taffy.fields().filter({
        selected: true
      }).each((function(_this) {
        return function(field) {
          var fieldKO, ho;
          fieldKO = new (_this.getDep('Seed_Options_Field'))(field, _this);
          fieldKO.field_num = _this.fields.length;
          if (field.id === _this.spp.currentFieldID) {
            _this.initialVisibleFieldNum = fieldKO.field_num;
          }
          fieldKO.setSurveyDetails(_this.handler.data.survey_details_by_field[field.id]);
          if ((field.planting_plan_id != null) && (field.planting_plan_hybrids != null)) {
            fieldKO.setPlantingPlan(field.planting_plan_id, field.planting_plan_hybrids, _this.taffy.hybrids, _this.selectionsKO, false);
          } else if ((field.rx_plan_id != null) && (field.rx_plan_hybrids != null)) {
            fieldKO.setRxPlan(field.rx_plan_id, field.hidden_planting_plan_id, field.rx_plan_hybrids, _this.taffy.hybrids, _this.selectionsKO, false);
          } else {
            if (field.hybrids_id != null) {
              ho = new HybridOption({
                id: field.hybrids_id
              }, _this.taffy.hybrids);
              fieldKO.hybrid_selection(ho);
              if (field.refuge_hybrids_id) {
                ho = new HybridOption({
                  id: field.refuge_hybrids_id
                }, _this.taffy.hybrids);
                fieldKO.refuge_selection(ho);
              }
            }
            if (field.low_yield_hybrids_id != null) {
              ho = new HybridOption({
                id: field.low_yield_hybrids_id
              }, _this.taffy.hybrids);
              fieldKO.low_yield_hybrid_selection(ho);
            }
          }
          return _this.fields.push(fieldKO);
        };
      })(this));
      this.spp.currentFieldID = null;
      delete this.spp.currentFieldID;
      if (this.fields.length && this.spp.makes_recommendations) {
        doSPP = this.spp.inputChanged || !this.spp.finished;
        return this._queueFields(doSPP);
      }
    };

    Form.prototype._queueFields = function(doSPP, i) {
      var field, n, numRequests, obj, postParams, ref, results;
      if (i == null) {
        i = 0;
      }
      numRequests = 1;
      if (isDebug()) {
        numRequests = (ref = window.numRequests) != null ? ref : numRequests;
      }
      if (i > this.fields.length - 1) {
        debugLog("Error: Tried to get results for field index " + i + ", but there are only " + this.fields.length + " fields");
        return;
      }
      field = this.fields[i];
      if (isDebug()) {
        if (this.requestTimes == null) {
          this.requestTimes = [];
          debugLog("num requests: " + numRequests);
          this._startTime(this);
        }
        this.requestTimes[i] = obj = {
          index: i,
          id: field.id
        };
        this._startTime(obj);
      }
      postParams = {
        id: this.spp_id,
        result_id: this.results_id,
        field_id: field.id,
        do_spp: doSPP
      };
      $.post('backend/grower/placement/spp/get-recommendations', postParams, (function(_this) {
        return function(response) {
          var done, j, k, len, len1, ref1, ref2, ref3, ref4, sum, times;
          field.handleResponse(response);
          if (i + numRequests < _this.fields.length) {
            _this._queueFields(doSPP, i + numRequests);
          }
          if (isDebug()) {
            obj = _this.requestTimes[i];
            _this._endTime(obj);
            done = true;
            ref1 = _this.requestTimes;
            for (j = 0, len = ref1.length; j < len; j++) {
              obj = ref1[j];
              if ((obj != null ? obj.endTime : void 0) == null) {
                done = false;
              }
            }
            if (done) {
              _this._endTime(_this);
              times = [];
              sum = 0;
              ref2 = _this.requestTimes;
              for (k = 0, len1 = ref2.length; k < len1; k++) {
                obj = ref2[k];
                times.push(parseInt(obj.elapsedTime.getTime()));
                sum += times[times.length - 1];
                debugLog("field " + obj.index + "(" + obj.id + "): " + obj.elapsedTimePretty);
              }
              times.sort(strnatcasecmp);
              debugLog("elapsed time: " + _this.elapsedTimePretty);
              debugLog("avg request: " + (Math.round(sum / _this.fields.length)) + "ms");
              debugLog("shortest request: " + ((ref3 = times[0]) != null ? ref3 : null) + "ms");
              return debugLog("longest request: " + ((ref4 = times[times.length - 1]) != null ? ref4 : null) + "ms");
            }
          }
        };
      })(this));
      if (i === 0) {
        n = 1;
        results = [];
        while (n < numRequests && n < this.fields.length) {
          results.push(this._queueFields(doSPP, n++));
        }
        return results;
      }
    };

    Form.prototype._startTime = function(obj) {
      var now;
      now = new Date();
      obj.startTime = now;
      return obj.startTimePretty = now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + '.' + now.getMilliseconds();
    };

    Form.prototype._endTime = function(obj) {
      var elapsed, now;
      now = new Date();
      elapsed = new Date(now - obj.startTime);
      obj.endTime = now;
      obj.endTimePretty = now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + '.' + now.getMilliseconds();
      obj.elapsedTime = elapsed;
      return obj.elapsedTimePretty = elapsed.getMinutes() + ' min, ' + elapsed.getSeconds() + '.' + elapsed.getMilliseconds() + 's';
    };

    Form.prototype._initKO = function() {
      this.processing = ko.observable(true);
      this.processing.subscribe((function(_this) {
        return function(processing) {
          return _this.handler.showCustomButtons();
        };
      })(this));
      this.doneProcessing = ko.observable(false);
      this.showProceed = ko.computed((function(_this) {
        return function() {
          return _this.processing() && _this.doneProcessing();
        };
      })(this));
      this.visibleFieldNum = ko.observable(this.initialVisibleFieldNum);
      delete this.initialVisibleFieldNum;
      this.visibleField = ko.computed((function(_this) {
        return function() {
          return _this.fields[_this.visibleFieldNum()];
        };
      })(this));
      this.visibleField.subscribe((function(_this) {
        return function(field) {
          return _this._setCurrentField(field.id);
        };
      })(this));
      this.hasPlantingPlan = ko.computed((function(_this) {
        return function() {
          var ref;
          return ((ref = _this.visibleField()) != null ? ref.planting_plan_id() : void 0) != null;
        };
      })(this));
      this.hasRxPlan = ko.computed((function(_this) {
        return function() {
          var ref;
          return ((ref = _this.visibleField()) != null ? ref.rx_plan_id() : void 0) != null;
        };
      })(this));
      this.hasAPlan = ko.computed((function(_this) {
        return function() {
          return _this.hasPlantingPlan() || _this.hasRxPlan();
        };
      })(this));
      this.hybridsChanged = ko.computed((function(_this) {
        return function() {
          var field, plannedHybridID, plannedHybrids, plannedRefugeID, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, selectedHybridID, selectedRefugeID;
          if (!_this.hasPlantingPlan()) {
            return false;
          }
          field = _this.visibleField();
          if (field == null) {
            return false;
          }
          plannedHybrids = (ref = field.plannedHybrids()) != null ? ref : [];
          if (!plannedHybrids.length) {
            return false;
          }
          plannedHybridID = (ref1 = (ref2 = plannedHybrids[0]) != null ? ref2.hybridID : void 0) != null ? ref1 : null;
          plannedRefugeID = (ref3 = (ref4 = plannedHybrids[1]) != null ? ref4.hybridID : void 0) != null ? ref3 : null;
          selectedHybridID = (ref5 = (ref6 = field.hybrid_selection()) != null ? ref6.id : void 0) != null ? ref5 : null;
          selectedRefugeID = (ref7 = (ref8 = field.refuge_selection()) != null ? ref8.id : void 0) != null ? ref7 : null;
          return plannedHybridID !== selectedHybridID || plannedRefugeID !== selectedRefugeID;
        };
      })(this));
      this.plannedFields = ko.computed((function(_this) {
        return function() {
          var arr, field, i, j, len, ref;
          arr = [];
          ref = _this.fields;
          for (i = j = 0, len = ref.length; j < len; i = ++j) {
            field = ref[i];
            if ((field.planting_plan_id() != null) || (field.rx_plan_id() != null)) {
              arr.push(i);
            }
          }
          return arr;
        };
      })(this));
      this.plantingPlans = ko.computed((function(_this) {
        return function() {
          var field, ids, j, len, ref;
          ids = [];
          ref = _this.fields;
          for (j = 0, len = ref.length; j < len; j++) {
            field = ref[j];
            if ((field.rx_plan_id() != null) && (field.hidden_planting_plan_id() != null)) {
              ids.push(field.hidden_planting_plan_id());
            } else if (field.planting_plan_id() != null) {
              ids.push(field.planting_plan_id());
            }
          }
          return ids;
        };
      })(this));
      this.showSpinner = ko.computed((function(_this) {
        return function() {
          var ref;
          return _this.spp.makes_recommendations && ((ref = _this.visibleField()) != null ? ref.showSpinner() : void 0);
        };
      })(this));
      this.showError = ko.computed((function(_this) {
        return function() {
          var ref;
          return (ref = _this.visibleField()) != null ? ref.showError() : void 0;
        };
      })(this));
      this.visibleHybrids = ko.computed((function(_this) {
        return function() {
          var ref, ref1;
          return (ref = (ref1 = _this.visibleField()) != null ? ref1.visibleHybrids() : void 0) != null ? ref : [];
        };
      })(this));
      this.showHybrids = ko.computed((function(_this) {
        return function() {
          return _this.visibleHybrids().length > 0;
        };
      })(this));
      this.canGetPrevHybrids = ko.computed((function(_this) {
        return function() {
          return _this.getPrevHybrids(true);
        };
      })(this));
      this.canGetNextHybrids = ko.computed((function(_this) {
        return function() {
          return _this.getNextHybrids(true);
        };
      })(this));
      this.visibleLowYieldHybrids = ko.computed((function(_this) {
        return function() {
          var ref, ref1;
          return (ref = (ref1 = _this.visibleField()) != null ? ref1.visibleLowYieldHybrids() : void 0) != null ? ref : [];
        };
      })(this));
      this.showLowYieldHybrids = ko.computed((function(_this) {
        return function() {
          return _this.visibleLowYieldHybrids().length > 0;
        };
      })(this));
      this.canGetPrevLowYieldHybrids = ko.computed((function(_this) {
        return function() {
          return _this.getPrevLowYieldHybrids(true);
        };
      })(this));
      this.canGetNextLowYieldHybrids = ko.computed((function(_this) {
        return function() {
          return _this.getNextLowYieldHybrids(true);
        };
      })(this));
      this.visibleRefuges = ko.computed((function(_this) {
        return function() {
          var ref, ref1;
          return (ref = (ref1 = _this.visibleField()) != null ? ref1.visibleRefuges() : void 0) != null ? ref : [];
        };
      })(this));
      this.showRefuges = ko.computed((function(_this) {
        return function() {
          return _this.visibleRefuges().length > 0;
        };
      })(this));
      this.canGetPrevRefuges = ko.computed((function(_this) {
        return function() {
          return _this.getPrevRefuges(true);
        };
      })(this));
      this.canGetNextRefuges = ko.computed((function(_this) {
        return function() {
          return _this.getNextRefuges(true);
        };
      })(this));
      this.refuge_mismatch = ko.computed((function(_this) {
        return function() {
          var ref, ref1, ref2, ref3, ref4;
          if (((ref = _this.visibleField()) != null ? (ref1 = ref.hybrid_selection()) != null ? (ref2 = ref1.refuge_options) != null ? ref2.length : void 0 : void 0 : void 0) > 0) {
            return false;
          }
          return (ref3 = _this.visibleField()) != null ? (ref4 = ref3.hybrid_selection()) != null ? ref4.requires_refuge : void 0 : void 0;
        };
      })(this));
      this.prevBtnText = ko.computed((function(_this) {
        return function() {
          if (_this.processing() || _this.visibleFieldNum() === 0) {
            return 'Back to Survey';
          }
          return 'Previous Field';
        };
      })(this));
      this.showNext = ko.computed((function(_this) {
        return function() {
          return (_this.visibleField() != null) && !_this.processing();
        };
      })(this));
      this.nextBtnText = ko.computed((function(_this) {
        return function() {
          if (_this.isLastField()) {
            return 'Done';
          }
          if (!_this.hasPlantingPlan() && !_this.hasRxPlan()) {
            return 'Skip Field';
          }
          return 'Next Field';
        };
      })(this));
      this.plantingDialogOpen = ko.observable(false);
      this.showPlanting = ko.computed((function(_this) {
        return function() {
          return (_this.visibleField() != null) && !_this.processing() && !_this.hasRxPlan();
        };
      })(this));
      this.plantingBtnText = ko.computed((function(_this) {
        return function() {
          if (_this.hasPlantingPlan()) {
            if (_this.hybridsChanged()) {
              return 'Replace Planting Plan';
            }
            return 'Edit Planting Plan';
          }
          return 'Create Planting Plan';
        };
      })(this));
      this.showRx = ko.computed((function(_this) {
        return function() {
          var rxPlanAspect;
          if ((_this.visibleField() == null) || _this.processing() || !_this.spp.enable_rx_plans) {
            return false;
          }
          if (_this.hasPlantingPlan()) {
            return false;
          }
          rxPlanAspect = _this.spp.getFieldAspectByName(_this.visibleField().id, 'Create Rx Maps');
          return !!(rxPlanAspect != null ? rxPlanAspect.value : void 0);
        };
      })(this));
      this.rxBtnText = ko.computed((function(_this) {
        return function() {
          if (_this.hasRxPlan()) {
            return 'Rx Plan Created';
          }
          return 'Create Rx Plan';
        };
      })(this));
      return this.showRxConvert = ko.computed((function(_this) {
        return function() {
          var rxPlanAspect;
          if ((_this.visibleField() == null) || _this.processing() || !_this.spp.enable_rx_plans) {
            return false;
          }
          if (_this.hasRxPlan() || !_this.hasPlantingPlan()) {
            return false;
          }
          rxPlanAspect = _this.spp.getFieldAspectByName(_this.visibleField().id, 'Create Rx Maps');
          return !!(rxPlanAspect != null ? rxPlanAspect.value : void 0);
        };
      })(this));
    };

    Form.prototype._setCurrentField = function(fieldID) {
      var postParams;
      postParams = {
        id: this.spp_id,
        result_id: this.results_id,
        field_id: fieldID
      };
      return $.post('backend/grower/placement/spp/set-current-field', postParams, function() {
        return void 0;
      });
    };

    Form.prototype.createPlantingPlan = function() {
      var field, replace_hybrids;
      field = this.visibleField();
      replace_hybrids = !this.hasPlantingPlan() || this.hybridsChanged();
      return field.saveSeedSelection((function(_this) {
        return function() {
          var factory;
          factory = new PlantingPlanFactory();
          factory.create(field, _this.handler, _this.spp, replace_hybrids);
          $(window).off('spp.planting-plan-saved');
          $(window).on('spp.planting-plan-saved', function(event, data) {
            field.setPlantingPlan(data.id, data.products, _this.taffy.hybrids, _this.selectionsKO, true);
            if (field === _this.visibleField()) {
              return _this.nextField();
            }
          });
          $(window).off('spp.planting-plans-copied');
          return $(window).on('spp.planting-plans-copied', function(event, data) {
            var copiedField, j, len, plan, ref, ref1, results;
            if (!((ref = data.plans) != null ? ref.length : void 0)) {
              return;
            }
            ref1 = data.plans;
            results = [];
            for (j = 0, len = ref1.length; j < len; j++) {
              plan = ref1[j];
              if (plan.year !== _this.spp.year) {
                continue;
              }
              copiedField = _.filter(_this.fields, {
                id: plan.fields_id
              })[0];

              /*
              products should be an array of objects with the properties:
                  id
                  fieldID
                  hybridName
                  treatmentID (optional)
                  treatmentName (optional)
                  units
               */
              results.push(copiedField != null ? copiedField.setPlantingPlan(plan.id, plan.products.map(function(product) {
                return {
                  id: product.id,
                  fieldID: plan.fields_id,
                  hybridName: product.hybrid_name,
                  treatmentID: product.treatments_id,
                  treatmentName: product.treatment_name,
                  units: +product.units
                };
              }), _this.taffy.hybrids, _this.selectionsKO, false) : void 0);
            }
            return results;
          });
        };
      })(this));
    };

    Form.prototype.convertPlanToRx = function() {
      var field, statusFn;
      field = this.visibleField();
      statusFn = (function(_this) {
        return function(status) {
          if (status != null) {
            return _this.writer.message_writer(status.type, status.msg, true);
          }
        };
      })(this);
      return (new PlantingToRxConverter()).create(field, this.spp, statusFn, (function(_this) {
        return function(data) {
          var products;
          products = data.hybrids.map(function(product) {
            return {
              fieldID: field.id,
              hybridID: product.id,
              hybridName: product.hybrids_name,
              treatmentID: product.treatments_id,
              treatmentName: product.treatments_name,
              units: +product.units
            };
          });
          field.setRxPlan(data.layers_id, data.planting_layers_id, products, _this.taffy.hybrids, _this.selectionsKO, true);
          if (field === _this.visibleField()) {
            return _this.nextField();
          }
        };
      })(this));
    };

    Form.prototype.createRxPlan = function() {
      var field;
      field = this.visibleField();
      return field.saveSeedSelection((function(_this) {
        return function() {
          return (new RxPlanFactory()).create(field, _this.spp, function(data) {
            var products;
            products = data.hybrids.map(function(product) {
              return {
                fieldID: field.id,
                hybridID: product.id,
                hybridName: product.hybrids_name,
                treatmentID: product.treatments_id,
                treatmentName: product.treatments_name,
                units: +product.units
              };
            });
            field.setRxPlan(data.layers_id, data.planting_layers_id, products, _this.taffy.hybrids, _this.selectionsKO, true);
            if (field === _this.visibleField()) {
              return _this.nextField();
            }
          });
        };
      })(this));
    };

    Form.prototype.endProcessing = function() {
      this.processing(false);
      $('.spp_header').html('<h3>Fit Seed to Field</h3>');
      $('.spp-units-display').show();
      return this.handler.setupDatatable();
    };

    Form.prototype.nextField = function() {
      if (!this.isLastField()) {
        if (this.plannedFields().length === this.fields.length && !this.spp.finished) {
          return this.finishSPP();
        } else {
          return this.visibleFieldNum(this.visibleFieldNum() + 1);
        }
      } else {
        if (this.plannedFields().length !== this.fields.length) {
          return this.handler.showSkippedFieldsDialog();
        } else {
          if (this.spp.finished) {
            return this.finishSPP(false);
          } else {
            return this.finishSPP();
          }
        }
      }
    };

    Form.prototype.prevField = function() {
      if (this.processing() || this.visibleFieldNum() === 0) {
        this.prevStep();
        return;
      }
      return this.visibleFieldNum(this.visibleFieldNum() - 1);
    };

    Form.prototype.prevStep = function() {
      return this.spp.goToStep(this.handler.num - 1);
    };

    Form.prototype.isLastField = function() {
      return this.visibleFieldNum() === (this.fields.length - 1);
    };

    Form.prototype.firstSkippedFieldNum = function() {
      var field, i, j, len, ref;
      ref = this.fields;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        field = ref[i];
        if (field.planting_plan_id() == null) {
          return i;
        }
      }
      return null;
    };

    Form.prototype.goToFirstSkippedField = function() {
      var num;
      num = this.firstSkippedFieldNum();
      if (num != null) {
        return this.visibleFieldNum(num);
      }
    };

    Form.prototype.finishSPP = function(doAjax) {
      var callback;
      if (doAjax == null) {
        doAjax = true;
      }
      if (doAjax) {
        callback = (function(_this) {
          return function() {
            return _this.handler.showFinishedDialog();
          };
        })(this);
        return this.spp.finish(callback);
      } else {
        return this.handler.showFinishedDialog();
      }
    };

    Form.prototype.getHybridButtonClass = function(hybrid) {
      var ref;
      return this._getButtonClass(hybrid, (ref = this.visibleField()) != null ? ref.hybrid_selection() : void 0);
    };

    Form.prototype.getLowYieldHybridButtonClass = function(hybrid) {
      var ref;
      return this._getButtonClass(hybrid, (ref = this.visibleField()) != null ? ref.low_yield_hybrid_selection() : void 0);
    };

    Form.prototype.getRefugeButtonClass = function(hybrid) {
      var ref;
      return this._getButtonClass(hybrid, (ref = this.visibleField()) != null ? ref.refuge_selection() : void 0);
    };

    Form.prototype._getButtonClass = function(hybrid, selected) {
      if (hybrid.id === (selected != null ? selected.id : void 0)) {
        return this.spanCls + ' btn-blue';
      } else {
        return this.spanCls + ' btn-light-blue';
      }
    };

    Form.prototype.getButtonContents = function(hybrid) {
      var btnHTML, buttonText, j, key, len, obj, ref, ref1, ref2, ref3, str, val;
      obj = this.btnContents;
      btnHTML = '';
      if (obj.title != null) {
        btnHTML += '<div class="title">' + hybrid[obj.title] + '</div>';
      }
      if (obj.subtitle != null) {
        btnHTML += '<div class="subtitle">' + hybrid[obj.subtitle] + '</div>';
      }
      if (obj.table != null) {
        ref = obj.table;
        for (key in ref) {
          val = ref[key];
          buttonText = key + ': ' + ((ref1 = hybrid[val]) != null ? ref1 : 'N/A');
          buttonText = buttonText.replace("'", '&#39;');
          btnHTML += "<div class='nowrap' title='" + buttonText + "'>" + buttonText + "</div>";
        }
      }
      if (obj.text != null) {
        ref2 = obj.text;
        for (j = 0, len = ref2.length; j < len; j++) {
          str = ref2[j];
          btnHTML += '<div class="nowrap">' + ((ref3 = hybrid[str]) != null ? ref3 : '') + '</div>';
        }
      }
      return btnHTML;
    };

    Form.prototype.getNextHybrids = function(checkOnly) {
      var ref;
      if (checkOnly == null) {
        checkOnly = false;
      }
      return (ref = this.visibleField()) != null ? ref.getNextHybrids(checkOnly) : void 0;
    };

    Form.prototype.getPrevHybrids = function(checkOnly) {
      var ref;
      if (checkOnly == null) {
        checkOnly = false;
      }
      return (ref = this.visibleField()) != null ? ref.getPrevHybrids(checkOnly) : void 0;
    };

    Form.prototype.selectHybrid = function(hybrid) {
      var ref;
      return (ref = this.visibleField()) != null ? ref.selectHybrid(hybrid) : void 0;
    };

    Form.prototype.getNextLowYieldHybrids = function(checkOnly) {
      var ref;
      if (checkOnly == null) {
        checkOnly = false;
      }
      return (ref = this.visibleField()) != null ? ref.getNextLowYieldHybrids(checkOnly) : void 0;
    };

    Form.prototype.getPrevLowYieldHybrids = function(checkOnly) {
      var ref;
      if (checkOnly == null) {
        checkOnly = false;
      }
      return (ref = this.visibleField()) != null ? ref.getPrevLowYieldHybrids(checkOnly) : void 0;
    };

    Form.prototype.selectLowYieldHybrid = function(hybrid) {
      var ref;
      return (ref = this.visibleField()) != null ? ref.selectLowYieldHybrid(hybrid) : void 0;
    };

    Form.prototype.getNextRefuges = function(checkOnly) {
      var ref;
      if (checkOnly == null) {
        checkOnly = false;
      }
      return (ref = this.visibleField()) != null ? ref.getNextRefuges(checkOnly) : void 0;
    };

    Form.prototype.getPrevRefuges = function(checkOnly) {
      var ref;
      if (checkOnly == null) {
        checkOnly = false;
      }
      return (ref = this.visibleField()) != null ? ref.getPrevRefuges(checkOnly) : void 0;
    };

    Form.prototype.selectRefuge = function(hybrid) {
      var ref;
      return (ref = this.visibleField()) != null ? ref.selectRefuge(hybrid) : void 0;
    };

    return Form;

  })(KoModel);

}).call(this);
